import { mutationNames } from '@/store/storeKeysettings'
import { Post } from '@/modules/wrapper/apiWrapper'
import appconfig from '@/store/modules/appconfig'
const state = {
  Twitter: {
    'Id': 0,
    'PageTitle': '',
    'RowCreated': null,
    'RowUpdated': null,
    'SubscriptionModuleActivation_Id': 0,
    'TwitterId': '',
    'Module_Id': '',
    'AccessToken':'',
    'AccessTokenSecretKey': '',
    'ConsumerKey':'',
    'ConsumerSecretKey':''
  },
  TwitterUserDetail: null,
  TwitterMediaDetail: null,
  TwitterVideoArray: {}
}

const mutations = {
    [mutationNames.SET_TWITTERDATA](state, data) {
      state.Twitter = data
    },
    [mutationNames.UPDATE_TWITTERDATA](state, data) {
      state.Twitter = data
    },
    [mutationNames.SET_TWITTERUSERDETAIL](state, pagecover) {
      state.TwitterUserDetail = pagecover.User
    },
    [mutationNames.SET_TWITTERMEDIADETAIL](state, media) {
      state.TwitterMediaDetail = media
    },
    [mutationNames.SET_TWITTERVIDEOARRAY](state, media) {
      state.TwitterVideoArray = media
    }
}

const actions = {
  initTwitterData: ({
    commit
  }) => {
    commit(mutationNames.SET_TWITTERDATA)
  },
  async getTwitterUserDetails({ dispatch, commit }, payload) {
    let TwitterPageCover = await Post(`${appconfig.state.AppConfig.Urls.WebAPIURL}/api/ModulesTwitter/UserInformation`, payload)
    commit(mutationNames.SET_TWITTERUSERDETAIL, TwitterPageCover)
    return TwitterPageCover
  },
  async getTwitterMediaDetails({ state, commit }, payload) {
    let TwitterMediaDetail = await Post(`${appconfig.state.AppConfig.Urls.WebAPIURL}/api/ModulesTwitter/GetUserStatus`, payload)
    commit(mutationNames.SET_TWITTERMEDIADETAIL, TwitterMediaDetail.statuses)
    return TwitterMediaDetail
  },
  resetTwitterMediaDetails({ state, commit }, payload) {
    commit(mutationNames.SET_TWITTERMEDIADETAIL, payload)
  },
  async updateTwitterVideoArray ({ state, commit}, obj) {
    commit(mutationNames.SET_TWITTERVIDEOARRAY, obj)
  },
  resetTwitterUserDetails({ state, commit }, payload) {
    commit(mutationNames.SET_TWITTERUSERDETAIL, payload)
  },
}
const getters = {
  Twitter: state => {
    return state.Twitter
  },
  TwitterUserDetail: state => {
    return state.TwitterUserDetail
  },
  TwitterMediaDetail: state => {
    return state.TwitterMediaDetail
  },
  TwitterVideoArray: state => {
    return state.TwitterVideoArray
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}




// WEBPACK FOOTER //
// ./src/store/modules/twitter.js